import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { useToast, useToastError } from "@/components/ui/use-toast";
import { useTeams } from "@/contexts/teams-provider";
import { useApi } from "@/hooks/useApi";
import { useTranslation } from "@/hooks/useTranslation";
import { useEffect, useState } from "react";
import { ButtonLoading } from "../button-loading";

export default function CardTeamSettingsName() {
  const toastError = useToastError();
  const { toast } = useToast();
  const api = useApi();
  const { teamSelected } = useTeams();
  const { t } = useTranslation();

  const [name, setName] = useState<string>(teamSelected?.name || "");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const save = async () => {
    setIsLoading(true);
    try {
      await api.post(`/my/team`, {
        name,
      });
      toast({
        variant: "default",
        title: t("team.components.settingsName.toast.success.title"),
        description: t(
          "team.components.settingsName.toast.success.description"
        ),
      });
    } catch (e) {
      toastError();
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setName(teamSelected?.name || "");
  }, [teamSelected?.name]);

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("team.components.settingsName.title")}</CardTitle>
        <CardDescription>
          {t("team.components.settingsName.description")}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <form>
          <Input
            placeholder={t("team.components.settingsName.placeholder")}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </form>
      </CardContent>
      <CardFooter className="px-6 py-4 border-t">
        <ButtonLoading onClick={save} isLoading={isLoading}>
          {t("team.components.settingsName.saveButton")}
        </ButtonLoading>
      </CardFooter>
    </Card>
  );
}
